import { Link } from 'react-router-dom'

function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-black backdrop-blur-sm text-white bg-opacity-60">
      <div className="container-width section-padding py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Tamar Valley Business Association</h3>
            <p className="text-gray-300 mb-4">
              Supporting and fostering local businesses within the Tamar Valley region of Northern Tasmania.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/p/Tamar-Valley-Business-Association-100070927818616/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label="Follow us on Facebook"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
            <nav className="space-y-2">
              <Link 
                to="/" 
                className="block text-gray-300 hover:text-white transition-colors duration-200"
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className="block text-gray-300 hover:text-white transition-colors duration-200"
              >
                About Us
              </Link>
              <Link 
                to="/contact" 
                className="block text-gray-300 hover:text-white transition-colors duration-200"
              >
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
            <div className="space-y-2 text-gray-300">
              <p>
                <span className="font-medium">Email:</span>{' '}
                <a 
                  href="mailto:tamarvalleybusinessassociation@gmail.com"
                  className="text-primary-300 hover:text-primary-200 transition-colors duration-200 break-words"
                >
                  tamarvalleybusinessassociation@gmail.com
                </a>
              </p>
              <p>
                <span className="font-medium">Location:</span>{' '}
                <a 
                  href="https://maps.app.goo.gl/em4EQaXQv2phzruF8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-300 hover:text-primary-200 transition-colors duration-200"
                >
                  Beaconsfield, Tasmania
                </a>
              </p>
              <p className="text-sm">
                Visit us at the Exeter markets for membership inquiries and networking opportunities.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} Tamar Valley Business Association. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm mt-2 md:mt-0">
            Empowering local businesses since 2023
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer 